<!---------------------------------new ui---------------------------------------------------->
<section class="content-header ">
    
    <div class="row mb-2 ">
    <div class="col-sm-6">
    <h1>Productions</h1>
    </div>
    </div>
   
    </section>

    <!--------------loader-------------------------->
    <!-- <div *ngIf=loaderShown class="loader"></div> -->
    <!----------------------------------------------->
      <div class="container">
              <div class="row stock-report-head-div ">
                <div class="row d-flex justify-content-between">
                  <div class="col-md-4 d-flex flex-column justify-content-center">
                    <label>Select Time Frame:</label>
                    <select class="form-select"  [(ngModel)]="selectedTimeFrame" (ngModelChange)="fromToAuto()">
                      <option value="al">All</option>
                      <option value="td">Today</option>
                      <option value="ys">Yesterday</option>
                      <option value="lw">Lastweek</option>
                      <option value="tm">This Month</option>
                      <option value="lm">Last Month</option>
                      <option value="ty">This Year</option>
                    </select>
           
                    <!-- <button mat-icon-button matSuffix (click)="clearTfselect()" style="position: absolute;right: 5px;top: 32px;">
                      <mat-icon >clear</mat-icon>
                    </button> -->
                  </div>

                  <div class="col-md-4 d-flex flex-column justify-content-center">
                    <label>From: </label>
                    <input type="date" [ngModel]="data.fromdate" (ngModelChange)="ngOnInit()" class="form-control report_stock_report_form" >
                  </div>

                  <div class="col-md-4 d-flex flex-column justify-content-center ">
                    <label>To: </label>
                    <input type="date" [ngModel]="data.todate" (ngModelChange)="ngOnInit()" class="form-control report_stock_report_form" >
                  </div>
            
                </div>
            
                
<!--                 
                <div class="row d-flex justify-content-end mt-3">
                  <div class="col-md-4 d-flex justify-content-center mt-sm-2 mt-md-0">
                    <button mat-button class="report_btn_style">Submit</button>
                   
                  </div>
                </div> -->
              </div>
            </div>
    <section class="content">
    
    <div class="card" >
    <div class="card-header">
    
    <div class="card-tools">
    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
    <i class="fas fa-minus"></i>
    </button>
    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
    <i class="fas fa-times"></i>
    </button>
    </div>
    </div>
    <div class="card-body p-0">
    <table class="table table-striped projects">
    <thead>
    <tr>
   

    <th style="width: 10%">
    Order Id
    </th>

    <th style="width: 25%">
    Date 
    </th>

    <th style="width: 20%">
    Transaction Type
    </th>

    <th style="width: 15%">
    Entity
    </th>
    
    <th style="width: 15%">
    Status
    </th>

    <th>
    </th>
   
    </tr>
    </thead>
    <tbody>

    <tr *ngFor="let c of output">
    <td>
    <a>
    {{c.order.order_number}}
    </a>
    </td>

    <td>
    {{DateFormat(c.date_time)}}
    </td>

    <td>
    {{c.transaction_type}}
    </td>
    
    <td>
    {{c.entity}}
    </td>

    <td>
    {{c.status}}
    </td>
    
    <td class="project-actions text-right">
    <a class="btn btn-primary btn-sm" (click)="ProductionDetails(c._id)">
    <i class="fas fa-folder">
    </i>
    View
    </a>
     <!----
    <a class="btn btn-info btn-sm left" (click)='getValue(c.brand_id);EditBrands()'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
  
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>

    --->
  </td>
    </tr>
    

    </tbody>
    </table>
    </div>
    
    </div>
    
    </section>
<!---------------------paging------------------------------------->
<ul class="pagination" *ngIf=CardShown>
  <li class="paginate_button page-item previous" id="example2_previous">
  <a  (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0" class="page-link count">Previous</a></li>
  
  <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0" class="page-link count">{{ New_count+1}}</a></li>
             
  <li class="paginate_button page-item next" id="example2_next" >
  <a  (click)="clicks_next()"  aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a></li>
  </ul>





    
